import $ from 'jquery'
import IMask from 'imask'

$(document).ready(function () {
  $('.select-packages__open-btn').on('click', function (e) {
    e.preventDefault()
    window.scrollTo({ top: 0, behavior: 'smooth' })
    $('.select-packages__modal').addClass('is-active')
    $('body').css('overflow', 'hidden')
  })

  $(document).on('click', function (e) {
    if ($(e.target).is('.more-details__modal')) {
      $(e.target).removeClass('modal-active')
      return
    }

    if (
      !$(e.target).closest(
        '.select-packages__modal-wrapper, .select-packages__open-btn'
      ).length &&
      !$(e.target).closest('.more-details__modal').length
    ) {
      $('.select-packages__modal').removeClass('is-active')
      $('body').css('overflow', 'auto')
    }
  })

  $('.single-menu__more-detail').on('click', function (e) {
    e.preventDefault()
    var modalId = $(this).attr('data-bs-target')
    $(modalId).addClass('modal-active')
  })

  $('.more-details__modal').on('click', function (e) {
    if ($(e.target).is('.more-details__modal')) {
      $(this).removeClass('modal-active')
    }
  })

  $('.more-details__close').on('click', function (e) {
    e.preventDefault()
    $(this).closest('.more-details__modal').removeClass('modal-active')
  })

  $('.select-packages__close-btn').on('click', function () {
    $('.select-packages__modal').removeClass('is-active')
    $('body').css('overflow', 'auto')
  })

  $('.single-menu__meal-checkbox').on('click', function () {
    var $this = $(this)

    if ($this.prop('checked')) {
      $('.single-menu__meal-checkbox').not($this).prop('checked', false)
    } else {
      $this.prop('checked', false)
    }
  })

  $('.single-menu__packages-checkbox').on('click', function () {
    var $this = $(this)

    if ($this.prop('checked')) {
      $('.single-menu__packages-checkbox').not($this).prop('checked', false)
    } else {
      $this.prop('checked', false)
    }
  })

  const phoneInput = document.getElementById('phone')

  if (phoneInput) {
    IMask(phoneInput, {
      mask: '+9\\0 000 000 00 00',
      lazy: false,
      placeholderChar: 'x',
    })
  }
  function getUrlParameter(name) {
    const params = new URLSearchParams(window.location.search)
    return params.get(name)
  }

  const limanParam = getUrlParameter('liman')
  if (limanParam) {
    const decodedLiman = decodeURIComponent(limanParam.replace(/\+/g, ' '))
    $('#harbor option').each(function () {
      if ($(this).val().trim() === decodedLiman.trim()) {
        $(this).prop('selected', true)
      }
    })
  }
})
